import 'ant-design-vue/lib/style/index.less' // antd core styles
import './components/kit/vendors/antd/themes/default.less' // default theme antd components
import './components/kit/vendors/antd/themes/dark.less' // dark theme antd components
import './global.scss' // app & third-party component styles

import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import NProgress from 'vue-nprogress'
import VueLayers from 'vuelayers'
import BootstrapVue from 'bootstrap-vue'
import moment from 'moment'
import VueGapi from 'vue-gapi'
import VueTour from 'vue-tour'

import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from './localization'
import './antd'
import './registerServiceWorker'

// mocking api
import './services/axios/fakeApi'

require('vue-tour/dist/vue-tour.css')

Vue.use(BootstrapVue)
Vue.use(VueLayers)
Vue.use(VueTour)

Vue.use(VueGapi, {
  apiKey: 'AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc',
  clientId: '1015973841778-t628ork85c8okkoeuivav2pf8rnfricf.apps.googleusercontent.com',
  discoveryDocs: ['https://youtubeanalytics.googleapis.com/$discovery/rest?version=v2', 'https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest'],
  scope: 'https://www.googleapis.com/auth/yt-analytics.readonly https://www.googleapis.com/auth/youtube.readonly',
})

Vue.filter('formatDate', function (value) {
  if (!value) return ''
  return moment(value.toString()).format('MM/DD/YYYY')
})

Vue.use(NProgress)
Vue.use(VuePageTitle, {
  prefix: 'PlannerVid | ',
  router,
})

Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

new Vue({
  router,
  store,
  nprogress,
  i18n,
  render: h => h(App),
}).$mount('#app')
